import { Spinner, theme as uiTheme } from '@mi-front/ui';
import { THUMBNAIL_HEIGHT } from '../consts';
import { ThumbnailImageMetadata } from '../types';
import { calculateThumbnailDisplayRatio, calculateThumbnailFrameWidth } from '../utils';
import { ThumbnailFrame } from './ThumbnailFrame';

interface Props {
  metadata: ThumbnailImageMetadata;
  targetHeight?: number;
  theme?: 'dark' | 'light';
}

export function LoadingThumbnail({
  metadata,
  targetHeight = THUMBNAIL_HEIGHT,
  theme = 'dark',
}: Props) {
  const displayRatio = calculateThumbnailDisplayRatio(metadata, targetHeight);
  const width = calculateThumbnailFrameWidth(metadata, displayRatio);

  return (
    <ThumbnailFrame>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: `${width}px`,
          height: `${targetHeight}px`,
          background: theme === 'dark' ? 'black' : uiTheme.aqua,
        }}
      >
        <Spinner color={theme === 'dark' ? uiTheme.aqua : 'white'} />
      </div>
    </ThumbnailFrame>
  );
}
